import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { color, display, flex, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, maxHeight, maxWidth, minHeight, minWidth, opacity, space, textAlign, themeGet, width } from 'styled-system';
import { Classes } from '@blueprintjs/core';
import classNames from 'classnames';
import { fontVariant, textDecoration, textOverflow, textTransform, whiteSpace } from './utils/typography';
const StyledText = styled.span.withConfig({
  displayName: "Text__StyledText",
  componentId: "sc-1vz74b3-0"
})(["&&{", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", "}"], space, width, flex, fontSize, display, fontWeight, color, textTransform, textDecoration, textAlign, fontStyle, fontVariant, letterSpacing, lineHeight, opacity, whiteSpace, textOverflow, minHeight, maxHeight, minWidth, maxWidth, ({
  hoverColor
}) => hoverColor && css(["&:hover{color:", ";}"], themeGet(`colors.${hoverColor}`, hoverColor)));
const Text = /*#__PURE__*/forwardRef(({
  as = 'span',
  className,
  monospace,
  runningText,
  large,
  small,
  showSkeleton,
  muted,
  disabled,
  ellipsis,
  ...rest
}, ref) => {
  let {
    fontSize: fontSizeProp
  } = rest;
  if (monospace && small) {
    fontSizeProp = 10;
  }
  return /*#__PURE__*/React.createElement(StyledText, _extends({
    ref: ref,
    as: as
  }, rest, {
    fontSize: fontSizeProp,
    className: classNames({
      [Classes.MONOSPACE_TEXT]: monospace,
      [Classes.RUNNING_TEXT]: runningText,
      [Classes.TEXT_LARGE]: large,
      [Classes.TEXT_SMALL]: small,
      [Classes.TEXT_MUTED]: muted,
      [Classes.TEXT_DISABLED]: disabled,
      [Classes.TEXT_OVERFLOW_ELLIPSIS]: ellipsis,
      [Classes.SKELETON]: showSkeleton
    }, className)
  }));
});
Text.displayName = 'Text';
export default Text;